/*
 * SPDX-FileCopyrightText: 2026 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import {HttpEvent, HttpHandler, HttpRequest,} from '@angular/common/http';
import {DOCUMENT, Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {
    CurrencyService,
    LanguageService,
    OccEndpointsService,
    SiteContextConfig,
    SiteContextInterceptor
} from "@spartacus/core";
import {AimoUxTypeService, UX_TYPE_APP} from "./aimo-ux-type.service";
import {map, switchMap, take} from "rxjs/operators";

@Injectable({providedIn: 'root'})
export class AimoSiteContextInterceptor extends SiteContextInterceptor {


    constructor(
        private languageService2: LanguageService,
        private currencyService2: CurrencyService,
        private occEndpoints2: OccEndpointsService,
        private config2: SiteContextConfig,
        private aimoUxTypeService: AimoUxTypeService,
        @Inject(DOCUMENT) private document: Document,
    ) {
        super(languageService2, currencyService2, occEndpoints2, config2);
    }

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        if (request.url.includes(this.occEndpoints2.getBaseUrl())) {
            return this.aimoUxTypeService.getActive()
                .pipe(
                    take(1),
                    map(uxType =>
                        request = request.clone({
                            setParams: {
                                lang: this.activeLang ?? '',
                                curr: this.activeCurr ?? '',
                                mobileApp: uxType === UX_TYPE_APP || this.document.location.href.includes('/' + UX_TYPE_APP + '/') ? 'true' : 'false',
                            },
                        })
                    ),
                    switchMap(() => next.handle(request))
                );
        } else {
            return next.handle(request);
        }

    }
}
